export interface ErrorResponse {
  code: string | null;
  message: string;
}

export enum ResponseStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
}

export enum ResponseCode {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
  SUCCESS = 200,
}

export interface ApiResponse<P = {}> {
  status?: ResponseStatus;
  statusCode?: number;
  data?: P;
  error?: ErrorResponse;
  errors?: ErrorResponse[];
  message?: string;
}

export interface WebWorkerResponse<T> {
  status: ResponseStatus;
  isLoading: boolean;
  data?: T;
  message?: string;
}
